import { IProductApiConfig } from '@/Foundation/ProductApi/platform/Scripts/models';
import { fetchAuthorizationSetting } from '@gn-audio/core/api/site-settings';
import { IAuthorizationSetting } from '@gn-audio/core/api/site-settings/models/authorization-setting';
import { buildMsalConfig, setUipConfig, } from '@gn-audio/core/auth/uip';
import { setMavenoidApiConfig } from '@gn-audio/core/auth/mavenoid';
import { setWebStoreApiConfig } from '@gn-audio/core/auth/web-store-api';
import { canBootstrapUip } from './can-bootstrap-uip';

export const bootstrapAuthApis = async (productApiConfig: IProductApiConfig) => {
  const settings: IAuthorizationSetting | null = await fetchAuthorizationSetting();

  if (!settings) {
    console.warn('No authorization settings were found');
    return;
  }

  if (await canBootstrapUip()) {
    setUipConfig(buildMsalConfig(settings));
  }

  setWebStoreApiConfig({
    baseUrl: settings.webStoreAPIBaseUrl,
    marketLocale: productApiConfig.language,
    siteContext: productApiConfig.siteContext,
    scopes: settings.webStoreAPIScopes,
    storage: localStorage,
  });

  setMavenoidApiConfig({
    scopes: settings.mavenoidAPIScopes
  });
};